/* eslint-disable no-useless-catch */
import { getDropboxSignClientID } from "../../utils/get-is-production";

export class DropboxSignUtil {
    public static DROPBOX_SIGN_CLIENT_ID = getDropboxSignClientID();
}
